import LandingPage, { type LandingPageData } from "./landing";
import { landingContent } from "@shared/landing-content";

const data: LandingPageData = {
  path: "/growth-marketing-d2c",
  seo: {
    nl: {
      title: "Growth Marketing Bureau voor D2C Merken | Wrkt Digital Amsterdam",
      description: "Wrkt Digital is hét growth marketing bureau voor D2C e-commerce merken in Nederland. Van paid social tot lifecycle marketing — een geïntegreerde aanpak voor duurzame groei.",
      keywords: "growth marketing bureau D2C, performance marketing webshop, e-commerce marketing bureau Amsterdam, growth agency D2C, growth marketing bureau Nederland, D2C groei bureau, full service online marketing, full service digital agency, growth audit, digital advertising agency",
    },
    en: {
      title: "Growth Marketing Agency for D2C Brands | Wrkt Digital Amsterdam",
      description: "Wrkt Digital is the growth marketing agency for D2C e-commerce brands in the Netherlands. From paid social to lifecycle marketing — an integrated approach for sustainable growth.",
      keywords: "growth marketing agency D2C, performance marketing webshop, e-commerce marketing agency Amsterdam, growth agency D2C, growth marketing agency Netherlands, full service online marketing, full service digital agency, growth audit, digital advertising agency",
    },
  },
  content: landingContent["/growth-marketing-d2c"],
};

export default function LandingGrowthMarketing() {
  return <LandingPage data={data} />;
}
